import * as React from 'react'
import FormGroup from '../../shared/project_form_controls/installers_selector_app/form_group'

const { I18n } = window as any

interface CreateLocationFormProps {
  data: {
    name: string
    number: string
    location_manager_id?: string
    location_manager_attributes?: {
      name?: string
      email?: string
    }
    address_attributes?: {
      line1?: string
      line2?: string
      zip?: string
      city?: string
      country?: string
    }
  }
  setData: (data: any) => void
  formRef: React.RefObject<HTMLFormElement>
  countries: Array<{ label: string; value: string }>
  locationManagers: Array<{ label: string; value: number }>
}

function CreateLocationForm({ data, setData, formRef, countries, locationManagers }: CreateLocationFormProps) {
  const addressData = data.address_attributes || {}
  const locationManagerData = data.location_manager_attributes || {}
  const isCreatingNewManager = data.location_manager_id === 'create_new'

  const updateAddressField = (field: string, value: string) => {
    setData({
      ...data,
      address_attributes: {
        ...addressData,
        [field]: value,
      },
    })
  }

  const updateLocationManagerField = (field: string, value: string) => {
    setData({
      ...data,
      location_manager_attributes: {
        ...locationManagerData,
        [field]: value,
      },
    })
  }

  const handleLocationManagerChange = (value: string) => {
    const newData: any = {
      ...data,
      location_manager_id: value,
    }

    // Clear location_manager_attributes if not creating new
    if (value !== 'create_new') {
      delete newData.location_manager_attributes
    }

    setData(newData)
  }

  return (
    <form className="default-form" action="#" method="POST" ref={formRef}>
      <ul>
        <FormGroup label={I18n.t('activerecord.attributes.location.name')} name="campaign_location_name">
          <input
            id="campaign_location_name"
            className="form-control"
            type="text"
            required
            name="name"
            value={data.name || ''}
            onChange={(e) =>
              setData({
                ...data,
                name: e.target.value,
              })
            }
          />
        </FormGroup>

        <FormGroup label={I18n.t('activerecord.attributes.location.number')} name="campaign_location_number">
          <input
            id="campaign_location_number"
            className="form-control"
            type="text"
            name="number"
            value={data.number || ''}
            onChange={(e) =>
              setData({
                ...data,
                number: e.target.value,
              })
            }
          />
        </FormGroup>

        <FormGroup label={I18n.t('activerecord.attributes.location.location_manager')} name="campaign_location_manager">
          <select
            id="campaign_location_manager"
            className="form-control"
            name="location_manager_id"
            value={data.location_manager_id || ''}
            onChange={(e) => handleLocationManagerChange(e.target.value)}
          >
            <option value=""></option>
            <option value="create_new">{I18n.t('campaigns.others.create_new_location_manager')}</option>
            {locationManagers.map((manager) => (
              <option key={manager.value} value={manager.value}>
                {manager.label}
              </option>
            ))}
          </select>
        </FormGroup>

        {isCreatingNewManager && (
          <fieldset className="">
            <legend>{I18n.t('activerecord.models.users/location_manager.one')}</legend>
            <FormGroup label={I18n.t('activerecord.attributes.users/base.name')} name="campaign_location_manager_name">
              <input
                id="campaign_location_manager_name"
                className="form-control"
                type="text"
                required
                name="location_manager_name"
                value={locationManagerData.name || ''}
                onChange={(e) => updateLocationManagerField('name', e.target.value)}
              />
            </FormGroup>

            <FormGroup label={I18n.t('activerecord.attributes.users/base.email')} name="campaign_location_manager_email">
              <input
                id="campaign_location_manager_email"
                className="form-control"
                type="email"
                required
                name="location_manager_email"
                value={locationManagerData.email || ''}
                onChange={(e) => updateLocationManagerField('email', e.target.value)}
              />
            </FormGroup>
          </fieldset>
        )}

        <fieldset className="">
          <legend>{I18n.t('activerecord.attributes.location.address')}</legend>
          <FormGroup label={I18n.t('activerecord.attributes.address.line1')} name="campaign_location_line1">
            <input
              id="campaign_location_line1"
              className="form-control"
              type="text"
              name="line1"
              value={addressData.line1 || ''}
              onChange={(e) => updateAddressField('line1', e.target.value)}
            />
          </FormGroup>

          <FormGroup label={I18n.t('activerecord.attributes.address.line2')} name="campaign_location_line2">
            <input
              id="campaign_location_line2"
              className="form-control"
              type="text"
              name="line2"
              value={addressData.line2 || ''}
              onChange={(e) => updateAddressField('line2', e.target.value)}
            />
          </FormGroup>

          <FormGroup label={I18n.t('activerecord.attributes.address.zip')} name="campaign_location_zip">
            <input
              id="campaign_location_zip"
              className="form-control"
              type="text"
              name="zip"
              value={addressData.zip || ''}
              onChange={(e) => updateAddressField('zip', e.target.value)}
            />
          </FormGroup>

          <FormGroup label={I18n.t('activerecord.attributes.address.city')} name="campaign_location_city">
            <input
              id="campaign_location_city"
              className="form-control"
              type="text"
              name="city"
              value={addressData.city || ''}
              onChange={(e) => updateAddressField('city', e.target.value)}
            />
          </FormGroup>

          <FormGroup label={I18n.t('activerecord.attributes.address.country')} name="campaign_location_country">
            <select
              id="campaign_location_country"
              className="form-control"
              name="country"
              value={addressData.country || ''}
              onChange={(e) => updateAddressField('country', e.target.value)}
            >
              <option value=""></option>
              {countries.map((country) => (
                <option key={country.value} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
          </FormGroup>
        </fieldset>
      </ul>
    </form>
  )
}

export default CreateLocationForm
